// loadash
import {
  isNull,
  cloneDeep,
  debounce,
  throttle,
} from 'lodash'

export const $isNull = (val) => {
  return isNull(val)
}

/**
 * @description: 防抖
 * @param {Function}  func 方法
 * @param {Number}  delay 延迟时长 ms
 * @param {Object}  options 选项对象 {
 *    @param {Boolean} leading 指定在延迟开始前调用
 *    @param {number} maxWait 允许被延迟的最大值
 *    @param {Boolean} trailing 指定在延迟结束后调用
 * }
 */
export function $debounce (func = () => {}, delay = 0, options = { leading: true }) {
  return debounce(func, delay, options)
}

/**
 * @description: 节流
 * @param {Function}  func 方法
 * @param {Number}  delay 延迟时长 ms
 * @param {Object}  options 选项对象 {
 *    @param {Boolean} leading 指定在延迟开始前调用
 *    @param {number} maxWait 允许被延迟的最大值
 *    @param {Boolean} trailing 指定在延迟结束后调用
 * }
 */
 export function $throttle (func = () => {}, delay = 0, options = { leading: true, trailing: false }) {
  return throttle(func, delay, options)
}

export function $cloneDeep (value) {
  return cloneDeep(value)
}